import type { IconData } from '@stacksjs/iconify-core'

export const tuneAdjustVolume: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M8 24a16 16 0 1 0 32 0a16 16 0 1 0-32 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 24a16 16 0 1 0 32 0a16 16 0 1 0-32 0M24 2v1m15.557 5.443l-.707.707m-29.7 29.7l-.707.707m12.354-12.352l-8 8M46 24h-1M3 24H2m37.557 15.557l-.707-.707M9.15 9.151l-.707-.707\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tuneAdjustVolume
